import axios from "../axios";


export const BlogApi = {
    get: async (currentPage: number, filters: Array<any>, searchQuery: string, blogContentId:string, isBlock:boolean): Promise<any> => {
        try {
            const contentId = document.querySelector("html")!.getAttribute("content-id");
            return await axios.get("blog/get", {
                params: {
                    currentPage: currentPage,
                    contentId: contentId,
                    filters: filters.join(";"),
                    searchQuery: searchQuery,
                    blogContentId:blogContentId,
                    isBlock:isBlock
                }
            });
        } catch (e) {
            return Promise.reject(e);
        }
    }
};
